import React, {PropTypes} from 'react';
import {Paper, MenuItem, Dialog, FlatButton, IconButton} from 'material-ui';
import RaisedButton from 'material-ui/RaisedButton';
import {Field, reduxForm} from 'redux-form';
import IntlPolyfill from 'intl';
import 'intl/locale-data/jsonp/fr';
import {connect} from 'react-redux';
import CloseIcon from 'material-ui/svg-icons/navigation/close';
import {Link} from 'react-router';
import moment from 'moment';

import {
    red400,
    blueGrey400,
    white
} from 'material-ui/styles/colors';

import {
    TextField,
    SelectField
} from 'redux-form-material-ui';

class NewTaskForm extends React.Component {

    constructor(props, context) {
        super(props, context);
    }

    render() {
        const closeButtonStyle = {
            position: 'absolute',
            right: 10,
            top: 10,
            color: 'white'
        };
        const actions = [
            <FlatButton
                key={1}
                label="Cancel"
                primary
                onTouchTap={this.handleClose}
            />,
            <FlatButton
                key={2}
                label="Discard"
                primary
                onTouchTap={this.handleClose}
            />
        ];
        const closeLink = "/timeSheet/" + this.props.date;
        let hoursErrors = false;
        if (this.refs.hours) {
            const hours = this.refs.hours.getRenderedComponent();
            hoursErrors = (hours.refs.component.state && hours.refs.component.state.errorText);
        }
        hoursErrors = this.props.errors.hours || this.props.errors.minutes;
        const title = (this.props.task) ? 'Modifier une tache' : 'Nouvelle tache';
        const submitButton = (this.props.task) ? 'Modifier' : 'Ajouter';
        const fieldId = (this.props.task) ? (<Field component={TextField} name="id" style={{display: 'none'}}/>) : (
            <div></div>);
        return (
            <div className="overlay">
                <Paper className="overlay-box">
                    <div style={{padding: 10, width: '100%'}}>
                        <div className="popinTitle">
                            <h3 style={{margin: 0}}>{title}</h3>
                            <Link to={closeLink}>
                                <IconButton style={closeButtonStyle}>
                                    <CloseIcon color={white}/>
                                </IconButton>
                            </Link>
                        </div>
                        <form onSubmit={this.props.handleSubmit} autoComplete="false">
                            <Field
                                name="project"
                                hintText="Choisir un projet"
                                floatingLabelFixed
                                floatingLabelText="Choisir un projet"
                                fullWidth
                                component={SelectField}
                                errorText={this.props.errors && this.props.errors.project && this.props.errors.project[0]}
                                style={{width: '100%'}}
                                menuStyle={{maxHeight: 200}}>
                                {this.props.myProjects.map((project) => (
                                    <MenuItem key={project.value} value={project.value} primaryText={project.text}/>
                                ))}
                            </Field>
                            <Field
                                name="taskType"
                                hintText="Choisir un type de tache"
                                floatingLabelFixed
                                floatingLabelText="Choisir un type de tache"
                                fullWidth
                                component={SelectField}
                                errorText={this.props.errors && this.props.errors.taskType && this.props.errors.taskType[0]}
                                style={{width: '100%'}}
                                menuStyle={{maxHeight: 200}}>
                                {this.props.taskTypes.map((taskType) => (
                                    <MenuItem key={taskType.value} value={taskType.value}
                                              primaryText={taskType.text}/>
                                ))}
                            </Field>
                            <div>
                                <Field
                                    tabindex="3"
                                    name="hours"
                                    hintStyle={{textAlign: 'center', width: '100%'}}
                                    hintText="01"
                                    component={TextField}
                                    errorStyle={{display: 'none'}}
                                    floatingLabelText="HH"
                                    floatingLabelFixed
                                    inputStyle={{textAlign: 'center'}}
                                    style={{width: 50}}
                                    withRef ref="hours"
                                /> :
                                <Field
                                    tabindex="4"
                                    name="minutes"
                                    component={TextField}
                                    label="Minutes"
                                    hintText="30"
                                    errorStyle={{display: 'none'}}
                                    hintStyle={{textAlign: 'center', width: '100%'}}
                                    floatingLabelFixed
                                    floatingLabelText="MM"
                                    floatingLabelStyle={{textAlign: 'center'}}
                                    inputStyle={{textAlign: 'center'}}
                                    style={{width: 50}}
                                />
                            </div>
                            <div style={{color: red400, fontSize: 12}}>{hoursErrors &&
                            <span>{hoursErrors[0]}</span>}</div>
                            <div style={{color: red400, fontSize: 12}}>{this.props.errors.duration &&
                            <span>{this.props.errors.duration[0]}</span>}</div>
                            <div>
                                <Field
                                    name="note"
                                    component={TextField}
                                    floatingLabelFixed
                                    hintText="Entrer un commentaire"
                                    floatingLabelText="Commentaires"
                                    style={{width: '100%'}}
                                    multiLine
                                    rows={2}/>
                            </div>
                            {fieldId}
                            <Field component={TextField} style={{display: 'none'}} name="date"
                                   value={this.props.date}/>
                            <div style={{display: 'inline-block', width: '100%', position: 'relative'}}>
                                <RaisedButton label="Réinitiliser"
                                              disabled={this.props.pristine || this.props.submitting}
                                              onClick={this.props.reset}/>
                                <RaisedButton type="submit" label={submitButton} primary
                                              style={{float: 'right'}}
                                              disabled={this.props.pristine || this.props.submitting}/> &nbsp;
                            </div>
                        </form>
                    </div>
                </Paper>
            </div>
        );
    }
}

NewTaskForm.propTypes = {
    date: PropTypes.string,
    errors: PropTypes.object,
    myProjects: PropTypes.array,
    taskTypes: PropTypes.array,
    pristine: PropTypes.bool,
    submitting: PropTypes.bool,
    reset: PropTypes.func,
    handleSubmit: PropTypes.func,
    task: PropTypes.object
};

export default connect(
    (state, ownProps) => {
        const formatNumber = (n) => (n < 10) ? '0' + n : n;
        return ({
            initialValues: (!ownProps.task) ? {date: ownProps.date} : {
                id: ownProps.task.id,
                date: ownProps.task.date,
                project: ownProps.task.project_id,
                taskType: ownProps.task.type_id,
                note: ownProps.task.note,
                hours: moment.duration(ownProps.task.duration).hours(),
                minutes: formatNumber(moment.duration(ownProps.task.duration).minutes())
            },
            myProjects: state.myProjects.map((project) => ({text: project.name, value: project.id})),
            taskTypes: state.taskTypes.map((taskTypes) => ({text: taskTypes.name, value: taskTypes.id}))
        });
    }
)(reduxForm({form: 'newProjectForm'})(NewTaskForm));


/** WEBPACK FOOTER **
 ** ./src/container/TimeSheetContainer/NewTaskForm.js
 **/